<icc-chip iccChipSmall iccChipStatus [color]="status?.colorRgbHex" [focusable]="false">
    <icc-icon name="state"></icc-icon>
    {{ status?.name || ('INTERFACE|Niezdefiniowany' | translate) }}
</icc-chip>